export default __webpack_public_path__ + "static/media/xec-icon.2154395c.png";